import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateUserRefreshTable } from "../../../redux/users/userSlice";
// COMPONENTS
import ButtonRefreshTable from "../../components/buttons/ButtonRefreshTable";
import ButtonCreateItem from "../../components/buttons/ButtonCreateItem";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function UsersHeader() {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation("global");
  const { permissionSet } = useSelector((state: RootState) => state.user);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleNavigateCreateNewUser = () => {
    navigate({ pathname: "/organization-management/users/create" });
  };

  const onClickReloadPage = () => {
    dispatch(updateUserRefreshTable(true));
    setTimeout(() => {
      dispatch(updateUserRefreshTable(false));
    }, 1000);
  };

  return (
    <div className="generalStyles__pageHeader">
      {hasPermission(Permission.UsersCreate, permissionSet ?? []) && (
        <div className="generalStyles__mlFix mt-1">
          <ButtonCreateItem
            onClick={handleNavigateCreateNewUser}
            label={t("userManagement.createNewUser")}
          />
        </div>
      )}
      {hasPermission(Permission.UsersView, permissionSet ?? []) && (
        <div className="generalStyles__mlFix mt-1">
          <ButtonRefreshTable
            onClick={onClickReloadPage}
            label={t("organizationManagement.refreshTable")}
          />
        </div>
      )}
    </div>
  );
}

export default UsersHeader;
